import type { ReactNode } from 'react';
import { Globe } from 'lucide-react';
import { VARIANT_SPECS, toGameVariant } from '@draughts/shared';

/** Variant border accent colors */
export const VARIANT_BORDER: Record<string, string> = {
  italian: '#E74C3C',
  international: '#2C5F2D',
  english: '#2563EB',
  brazilian: '#F59E0B',
};

/** Variant icons */
export const VARIANT_ICON: Record<string, ReactNode> = {
  italian: <>IT</>,
  international: <Globe size={14} />,
  english: <>EN</>,
  brazilian: <>BR</>,
};

/** Normalize variant string to a canonical key */
export function getVariantKey(variant: string): string {
  return (variant || 'international').toLowerCase();
}

/**
 * Flag emoji + short 3-letter code for a variant pill. Sourced from the shared
 * variant metadata (VARIANT_SPECS) so every variant is covered — not just the
 * main four. International (FMJD) and the other country-less variants carry their
 * own declared emoji (🌍, ⬡, 🎲, …) in that metadata.
 */
export function variantPill(variant: string): { flag: ReactNode; code: string } {
  const spec = VARIANT_SPECS[toGameVariant(variant)];
  return {
    flag: <span className="variant-flag" aria-hidden="true">{spec.ui.flagEmoji}</span>,
    code: spec.code.toUpperCase(),
  };
}
